module.exports = __webpack_public_path__ + "static/media/audio-slash.30e680f9.svg";